// src/api/courseService.ts
import { gql } from '@apollo/client';
import { courseClient } from './client';
import { API_COURSE_URL, AUTH_TOKEN_KEY } from '../utils/constants';

// interface CreatedBy {
//   _id: string;
//   name: string;
// }

// interface Course {
//   _id: string;
//   title: string;
//   description: string;
//   language: string;
//   thumbnail: string;
//   desktopAvailable: boolean;
//   created_by: CreatedBy;
//   createdAt: string;
//   deletedBy: { _id: string } | null;
//   deletedAt: string | null;
// }

interface ApiResponse {
  status: number;
  message: string;
  data?: any;
}

interface CreateCourseResponse {
  status: number;
  message: string;
  data?: any;
}

interface CertificateResponse {
  status: number;
  message: string;
  data?: any;
}

interface CourseMembersResponse {
  status: number;
  message: string;
  totalMembers?: number;
  totalWatched?: number;
  data?: any[];
}

interface GroupListResponse {
  status: number;
  message: string;
  data?: { id: string; name: string; slug?: string; channelType?: string }[];
}

export const getImageAsObjectUrl = async (
  url: string | null
): Promise<string> => {
  if (!url) return "";

  try {
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`,
      },
    });

    if (!response.ok) {
      console.error("Failed to fetch image:", response.status);
      return url;
    }

    const blob = await response.blob();

    return URL.createObjectURL(blob);
  } catch (error) {
    console.error("Error converting image to object URL:", error);
    return url;
  }
};

// Helper function to append token to URLs
export const appendTokenToUrl = (url: string | null): string | null => {
  if (!url) return null;
  
  // Skip if it's already a base64 data or already has a token
  if (url.startsWith('data:') || url.includes('token=')) {
    return url;
  }
  
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  if (!token) return url;
  
  // Check if URL already has query parameters
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}token=${encodeURIComponent(token)}`;
};

// Price Detail Interface
interface PriceDetail {
  _id?: string;
  price: number;
  actualPrice: number;
  validityType: string;
  validityInDays: number;
  gstRateId: {
    _id: string;
    gstPercent: number;
  };
}

// Course Price Interface
// interface CoursePrice {
//   _id: string;
//   courseId: {
//     _id: string;
//     title: string;
//   };
//   priceDetail: PriceDetail[];
//   createdBy?: {
//     _id: string;
//     name: string;
//   };
//   updatedBy?: {
//     _id: string;
//     name: string;
//   };
//   createdAt?: string;
//   updatedAt?: string;
// }

// export const getAllCourses = async (): Promise<ApiResponse> => {
//   try {
//     const GET_ALL_COURSES = gql`
//       query GetAllCourses {
//         getallCourses {
//           status
//           message
//           data {
//             _id
//             title
//             description
//             language
//             thumbnail
//             desktopAvailable
//             creatationStage
//             CourseChannel
//             PublishStatus
//             created_by {
//               _id
//               name
//             }
//             createdAt
//             deletedBy {
//               _id
//             }
//             deletedAt
//           }
//         }
//       }
//     `;


//     const response = await courseClient.query({
//       query: GET_ALL_COURSES,
//       fetchPolicy: 'network-only',
//     });
//     console.log("GraphQL Response:", response);
//     if (response.data?.getallCourses && response.data.getallCourses.data) {
//       // Process thumbnails to add token
//       const coursesWithToken = response.data.getallCourses.data.map((course: any) => ({
//         ...course,
//         thumbnail: appendTokenToUrl(course.thumbnail)
//       }));
      
//       return {
//         ...response.data.getallCourses,
//         data: coursesWithToken
//       };
//     }
//     return {
//       status: 500,
//       message: 'Failed to fetch courses - no data returned'
//     };
//   } catch (error: any) {
//     console.error('Error fetching courses:', error);
//     if (error.networkError) {
//       return {
//         status: 503,
//         message: 'Network error: Please check your connection'
//       };
//     }
    
//     if (error.graphQLErrors && error.graphQLErrors.length > 0) {
//       return {
//         status: 400,
//         message: error.graphQLErrors[0].message
//       };
//     }
//     return {
//       status: 500,
//       message: error.message || 'Failed to fetch courses'
//     };
//   }
// };
export const getAllCourses = async (): Promise<ApiResponse> => {
  try {
    const GET_ALL_COURSES = gql`
      query GetAllCourses($userId: String) {
        getallCourses(userId: $userId) {
          status
          message
          data {
            _id
            title
            description
            language
            thumbnail
            desktopAvailable
            creatationStage
            PublishStatus
            courseType
            webinarChannel
            created_by {
              _id
              name
            }
             updatedBy {
              _id
              name
            }
            updatedAt
            createdAt
            deletedBy {
              _id
            }
            deletedAt
          }
        }
      }
    `;

    // SSR-safe localStorage access for the requesting user's id
    let userId: string | undefined;
    if (typeof window !== 'undefined') {
      try {
        const raw = localStorage.getItem('userData');
        if (raw) {
          const userData = JSON.parse(raw);
          userId = userData?._id;
        }
      } catch (e) {
        console.error('Failed to parse userData from localStorage:', e);
      }
    }

    const response = await courseClient.query({
      query: GET_ALL_COURSES,
      variables: { userId },
      fetchPolicy: 'network-only',
    });
    console.log("GraphQL Response:", response);
    if (response.data?.getallCourses && response.data.getallCourses.data) {
      // Process thumbnails to add token
      const coursesWithToken = response.data.getallCourses.data.map((course: any) => ({
        ...course,
        thumbnail: appendTokenToUrl(course.thumbnail)
      }));

      return {
        ...response.data.getallCourses,
        data: coursesWithToken
      };
    }
    return {
      status: 500,
      message: 'Failed to fetch courses - no data returned'
    };
  } catch (error: any) {
    console.error('Error fetching courses:', error);
    if (error.networkError) {
      return {
        status: 503,
        message: 'Network error: Please check your connection'
      };
    }
    
    if (error.graphQLErrors && error.graphQLErrors.length > 0) {
      return {
        status: 400,
        message: error.graphQLErrors[0].message
      };
    }
    return {
      status: 500,
      message: error.message || 'Failed to fetch courses'
    };
  }
};

export const getCourseById = async (id: string): Promise<ApiResponse> => {
  if (!id) {
    return {
      status: 400,
      message: 'Invalid course ID',
    };
  }
  try {
    const GET_COURSE = gql`
      query GetCourse($id: String!) {
        course(id: $id) {
          status
          message
          data {
            _id
            title
            description
            language
            thumbnail
            desktopAvailable
            isVerificationNeeded
            creatationStage
            PublishStatus
            courseType
            webinarChannel
            certificateEnable
            created_by {
              _id
              name
            }
            createdAt
          }
        }
      }
    `;
    const response = await courseClient.query({
      query: GET_COURSE,
      variables: { id },
      fetchPolicy: 'network-only',
    });
    if (response.data?.course && response.data.course.data) {
      // Process thumbnail to add token
      const courseWithToken = {
        ...response.data.course.data,
        thumbnail: appendTokenToUrl(response.data.course.data.thumbnail)
      };
      
      return {
        ...response.data.course,
        data: courseWithToken
      };
    }
    return {
      status: 404,
      message: 'Course not found'
    };
  } catch (error: any) {
    console.error('Error fetching course:', error);
    if (error.networkError) {
      return {
        status: 503,
        message: 'Network error: Please check your connection'
      };
    }
    
    if (error.graphQLErrors && error.graphQLErrors.length > 0) {
      return {
        status: 400,
        message: error.graphQLErrors[0].message
      };
    }
    return {
      status: 500,
      message: error.message || 'Error fetching course data'
    };
  }
};

export const createCourse = async (courseData: {
  file?: File | null;
  title: string;
  description: string;
  language: string;
  desktopAvailable: boolean;
  created_by: string;
  isVerificationNeeded?: boolean;
  courseType?: string;
  webinarChannel?: string | null;
}): Promise<CreateCourseResponse> => {
  try {
    const formData = new FormData();
    formData.append('operations', JSON.stringify({
      query: `
        mutation CreateCourse(
          $file: Upload,
          $title: String!,
          $description: String,
          $language: String,
          $desktopAvailable: Boolean!,
          $created_by: String!,
          $isVerificationNeeded: Boolean,
          $courseType: String,
          $webinarChannel: String
        ) {
          createCourse(
            thumbnail: $file,
            title: $title,
            description: $description,
            language: $language,
            desktopAvailable: $desktopAvailable,
            created_by: $created_by
            isVerificationNeeded: $isVerificationNeeded,
            courseType: $courseType,
            webinarChannel: $webinarChannel
          ) {
            status
            message
            data {
              _id
              title
              thumbnail
              courseType
              webinarChannel
             
            }
          }
        }
      `,
      variables: {
        file: courseData.file ? null : undefined,
        title: courseData.title,
        description: courseData.description,
        language: courseData.language,
        desktopAvailable: courseData.desktopAvailable,
        created_by: courseData.created_by,
        isVerificationNeeded: courseData.isVerificationNeeded,
        courseType: courseData.courseType,
        webinarChannel: courseData.webinarChannel
      }
    }));
    if (courseData.file) {
      formData.append('map', JSON.stringify({ "0": ["variables.file"] }));
      formData.append('0', courseData.file);
    }
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: formData
    });
    const result = await response.json();
    return result.data?.createCourse || {
      status: 500,
      message: 'Failed to create course'
    };
  } catch (error: any) {
    console.error('Error creating course:', error);
    return {
      status: 500,
      message: error.message || 'Error creating course'
    };
  }
};

export const updateCourse = async (courseData: {
  id: string;
  user_id: string;
  file?: File;
  title?: string;
  description?: string;
  language?: string;
  desktopAvailable?: boolean;
  isVerificationNeeded?: boolean;
  courseType?: string;
  webinarChannel?: string | null;
  certificateEnable?: boolean;
}): Promise<CreateCourseResponse> => {
  try {
    // Check if we have a file to upload
    const hasFile = courseData.file && courseData.file instanceof File;
    
    if (hasFile) {
      // Use FormData for file upload
      const formData = new FormData();
      formData.append('operations', JSON.stringify({
        query: `
          mutation UpdateCourse(
            $id: String!,
            $user_id: String,
            $file: Upload,
            $title: String,
            $description: String,
            $language: String,
            $desktopAvailable: Boolean,
            $isVerificationNeeded: Boolean,
            $courseType: String,
            $webinarChannel: String   
            $certificateEnable: Boolean       
          ) {
            updateCourse(
              id: $id,
              user_id: $user_id,
              thumbnail: $file,
              title: $title,
              description: $description,
              language: $language,
              desktopAvailable: $desktopAvailable,
              isVerificationNeeded: $isVerificationNeeded,
              courseType: $courseType,
              webinarChannel: $webinarChannel
              certificateEnable: $certificateEnable
            ) {
              status
              message
              data {
                _id
                title
                thumbnail
                courseType
                webinarChannel
                updatedBy 
                updatedAt
              }
            }
          }
        `,
        variables: {
          id: courseData.id,
          user_id: courseData.user_id,
          file: null,
          title: courseData.title,
          description: courseData.description,
          language: courseData.language,
          desktopAvailable: courseData.desktopAvailable,
          isVerificationNeeded: courseData.isVerificationNeeded,
          courseType: courseData.courseType,
          webinarChannel: courseData.webinarChannel,
          certificateEnable: courseData.certificateEnable
        }
      }));
      
      formData.append('map', JSON.stringify({ "0": ["variables.file"] }));
      formData.append('0', courseData.file as File);
      
      const response = await fetch(`${API_COURSE_URL}/graphql`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
        },
        body: formData
      });
      
      const result = await response.json();
      return result.data?.updateCourse || {
        status: 500,
        message: 'Failed to update course'
      };
    } else {
      // Use regular JSON request without file
      const response = await fetch(`${API_COURSE_URL}/graphql`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
        },
        body: JSON.stringify({
          query: `
              mutation UpdateCourse(
                $id: String!,
                $user_id: String,
                $title: String,
                $description: String,
                $language: String,
                $desktopAvailable: Boolean,
                $isVerificationNeeded: Boolean,
                $courseType: String,
                $webinarChannel: String,
                $certificateEnable: Boolean             
              ) {
                updateCourse(
                  id: $id,
                  user_id: $user_id,
                  title: $title,
                  description: $description,
                  language: $language,
                  desktopAvailable: $desktopAvailable,
                  isVerificationNeeded: $isVerificationNeeded,
                  courseType: $courseType,
                  webinarChannel: $webinarChannel
                  certificateEnable: $certificateEnable
                ) {
                  status
                  message
                  data {
                    _id
                    title
                    thumbnail
                    courseType
                    webinarChannel
                  }
                }
              }
            `,
            variables: {
              id: courseData.id,
              user_id: courseData.user_id,
              title: courseData.title,
              description: courseData.description,
              language: courseData.language,
              desktopAvailable: courseData.desktopAvailable,
              isVerificationNeeded: courseData.isVerificationNeeded,
              courseType: courseData.courseType,
              webinarChannel: courseData.webinarChannel,
              certificateEnable: courseData.certificateEnable
            }
        })
      });
      
      const result = await response.json();
      return result.data?.updateCourse || {
        status: 500,
        message: 'Failed to update course'
      };
    }
  } catch (error: any) {
    console.error('Error updating course:', error);
    return {
      status: 500,
      message: error.message || 'Error updating course'
    };
  }
};

export const createCourseModule = async (moduleData: {
  title: string;
  description?: string;
  order: number;
  courseId: string;
}) => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          mutation createCourseModule(
            $title: String!, 
            $description: String, 
            $order: Int, 
            $courseId: String!
          ) {
            createCourseModule(
              title: $title,
              description: $description,
              order: $order,
              courseId: $courseId
            ) {
              status
              message
              data {
                _id
                title
                order
                description
              }
            }
          }
        `,
        variables: moduleData
      })
    });
    const result = await response.json();
    return result.data?.createCourseModule || {
      status: 500,
      message: 'Failed to create module'
    };
  } catch (error: any) {
    console.error('Error creating module:', error);
    return {
      status: 500,
      message: error.message || 'Error creating module'
    };
  }
};

export const updateCourseModule = async (moduleData: {
  id: string;
  user_id: string;
  title?: string;
  description?: string;
  order?: number;
}) => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          mutation UpdateCourseModule(
            $id: String!, 
            $title: String, 
            $description: String, 
            $order: Int,
            $user_id: String!
          ) {
            updateCourseModule(
              id: $id, 
              title: $title, 
              description: $description, 
              order: $order,
              user_id: $user_id
            ) {
              status
              message
              data {
                _id
                title
                description
                order
                updatedBy 
                updatedAt
              }
            }
          }
        `,
        variables: moduleData
      })
    });
    const result = await response.json();
    return result.data?.updateCourseModule || {
      status: 500,
      message: 'Failed to update module'
    };
  } catch (error: any) {
    console.error('Error updating module:', error);
    return {
      status: 500,
      message: error.message || 'Error updating module'
    };
  }
};

export const deleteCourseModule = async (id: string) => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          mutation DeleteCourseModule($id: String!) {
            deleteCourseModule(id: $id) {
              status
              message
            }
          }
        `,
        variables: { id }
      })
    });
    const result = await response.json();
    return result.data?.deleteCourseModule || {
      status: 500,
      message: 'Failed to delete module'
    };
  } catch (error: any) {
    console.error('Error deleting module:', error);
    return {
      status: 500,
      message: error.message || 'Error deleting module'
    };
  }
};

export const softDeleteCourseModule = async (
  id: string,
  user_id: string
) => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          mutation SoftDeleteCourseModule(
            $id: String!,
            $user_id: String
          ) {
            softDeleteCourseModule(
              id: $id,
              user_id: $user_id
            ) {
              status
              message
            }
          }
        `,
        variables: {
          id,
          user_id
        }
      })
    });

    const result = await response.json();

    if (result.errors) {
      console.error("GraphQL module delete error:", result.errors);

      return {
        status: 500,
        message: result.errors[0]?.message || "Failed to delete module"
      };
    }

    return result.data?.softDeleteCourseModule || {
      status: 500,
      message: "Failed to delete module"
    };

  } catch (error: any) {
    console.error("Error deleting module:", error);

    return {
      status: 500,
      message: error.message || "Error deleting module"
    };
  }
};


export const softDeleteCourseModuleLesson = async (
  id: string,
  user_id: string
) => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          mutation SoftDeleteCourseModuleLesson(
            $id: ID!,
            $user_id: String
          ) {
            softDeleteCourseModuleLesson(
              id: $id,
              user_id: $user_id
            ) {
              status
              message
            }
          }
        `,
        variables: {
          id,
          user_id
        }
      })
    });

    const result = await response.json();

    if (result.errors) {
      console.error("GraphQL lesson delete error:", result.errors);

      return {
        status: 500,
        message: result.errors[0]?.message || "Failed to delete lesson"
      };
    }

    return result.data?.softDeleteCourseModuleLesson || {
      status: 500,
      message: "Failed to delete lesson"
    };

  } catch (error: any) {
    console.error("Error deleting lesson:", error);

    return {
      status: 500,
      message: error.message || "Error deleting lesson"
    };
  }
};

// ─── Chunked parallel upload ────────────────────────────────────────────────
const CHUNK_SIZE = 10 * 1024 * 1024; // 10 MB per chunk
const PARALLEL_CHUNKS = 5;           // upload 5 chunks simultaneously

const uploadFileInChunks = async (
  file: File,
  onProgress?: (percent: number) => void
): Promise<string> => {
  const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
  const token = localStorage.getItem(AUTH_TOKEN_KEY);

  // 1. Open an upload session on the server
  const initRes = await fetch(`${API_COURSE_URL}/upload/init`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({ filename: file.name, totalChunks }),
  });

  if (!initRes.ok) throw new Error('Failed to initialise upload session');
  const { uploadId } = await initRes.json();

  let completedChunks = 0;

  // Upload one 10 MB slice and update progress
  const uploadSingleChunk = async (chunkIndex: number) => {
    const start = chunkIndex * CHUNK_SIZE;
    const end = Math.min(start + CHUNK_SIZE, file.size);
    const chunk = file.slice(start, end);

    const res = await fetch(
      `${API_COURSE_URL}/upload/chunk?uploadId=${uploadId}&chunkIndex=${chunkIndex}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/octet-stream',
          'Authorization': `Bearer ${token}`,
        },
        body: chunk,
      }
    );

    if (!res.ok) throw new Error(`Failed to upload chunk ${chunkIndex}`);

    completedChunks++;
    // Reserve the last 5 % for the assembly step
    if (onProgress) onProgress(Math.round((completedChunks / totalChunks) * 95));
  };

  // 2. Upload in batches of PARALLEL_CHUNKS
  for (let i = 0; i < totalChunks; i += PARALLEL_CHUNKS) {
    const batch: Promise<void>[] = [];
    for (let j = i; j < Math.min(i + PARALLEL_CHUNKS, totalChunks); j++) {
      batch.push(uploadSingleChunk(j));
    }
    await Promise.all(batch);
  }

  // 3. Ask the server to assemble the chunks into the final file
  const completeRes = await fetch(`${API_COURSE_URL}/upload/complete`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({ uploadId }),
  });

  if (!completeRes.ok) throw new Error('Failed to assemble uploaded file');
  const { filePath } = await completeRes.json();

  if (onProgress) onProgress(100);
  return filePath;
};
// ────────────────────────────────────────────────────────────────────────────

/**
 * Upload a thumbnail for an existing lesson using a small multipart GraphQL call.
 * Keeps the Upload scalar completely out of the chunked-video creation path,
 * avoiding the null→{} serialisation issue that the Upload scalar rejects.
 */
const uploadThumbnailForLesson = async (
  lessonId: string,
  thumbnailFile: File,
  lessonType: string = 'video',
  userID: string
): Promise<void> => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  // lessonType is included so processLessonWithUpload's thumbnail branch triggers.
  const variables = {
    id: lessonId,
    user_id: userID,
    input: { lessonThumbnail: null as null, lessonType },
  };
  const query = `
    mutation UpdateCourseLessonThumbnail($id: ID!, $user_id: String, $input: UpdateCourseLessonInput!) {
      updateCourseModuleLesson(id: $id, user_id: $user_id, input: $input) {
        status
        message
      }
    }
  `;
  const formData = new FormData();
  formData.append('operations', JSON.stringify({ query, variables }));
  formData.append('map', JSON.stringify({ '0': ['variables.input.lessonThumbnail'] }));
  formData.append('0', thumbnailFile);

  const res = await fetch(`${API_COURSE_URL}/graphql`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${token}` },
    body: formData,
  });
  if (!res.ok) throw new Error('Thumbnail upload failed');
};

export const createCourseModuleLesson = async (
  lessonData: {
    coursemoduleId: string;
    courseId: string;
    title: string;
    description: string;
    lessonType: string;
    order: number;
    duration: number | null;
    file?: File;
    thumbnailFile?: File;
    questions?: any[];
  },
  onProgress?: (percent: number) => void
) => {
  try {
    console.log("Creating lesson with data:", lessonData);

    // ── Video lesson: upload content in chunks, then send path via GraphQL ──
    if (lessonData.lessonType === 'video' && lessonData.file) {
      const uploadedFilePath = await uploadFileInChunks(lessonData.file, onProgress);
      console.log("Chunked upload complete, assembled path:", uploadedFilePath);

      const variables: any = {
        uploadedFilePath,
        courseId: lessonData.courseId,
        coursemoduleId: lessonData.coursemoduleId,
        title: lessonData.title,
        description: lessonData.description,
        lessonType: lessonData.lessonType,
        order: lessonData.order,
        duration: lessonData.duration !== null ? lessonData.duration : undefined,
        questions: lessonData.questions || [],
      };

      const gqlQuery = `
        mutation createCourseModuleLesson(
          $uploadedFilePath: String,
          $courseId: ID!,
          $coursemoduleId: ID!,
          $title: String!,
          $description: String!,
          $lessonType: String,
          $order: Int,
          $duration: Int,
          $questions: [QuestionInput]
        ) {
          createCourseModuleLesson(
            courseId: $courseId,
            coursemoduleId: $coursemoduleId,
            title: $title,
            description: $description,
            uploadedFilePath: $uploadedFilePath,
            lessonType: $lessonType,
            order: $order,
            duration: $duration,
            questions: $questions
          ) {
            status
            message
            data {
              _id
              title
              lessonThumbnail
              videoStatus
              questions { questionText options { answertext isCorrect explanation } }
            }
          }
        }
      `;

      const formData = new FormData();
      formData.append('operations', JSON.stringify({ query: gqlQuery, variables }));
      formData.append('map', '{}');

      const response = await fetch(`${API_COURSE_URL}/graphql`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}` },
        body: formData,
      });

      const result = await response.json();
      console.log("GraphQL response (chunked create):", result);

      if (result.errors?.length) {
        console.error("GraphQL errors:", result.errors);
        return { status: 500, message: result.errors[0]?.message || 'GraphQL error' };
      }

      const lessonResult = result.data?.createCourseModuleLesson;

      // Step 2: attach thumbnail via a separate small upload (avoids Upload scalar issue)
      if (lessonResult?.status < 400 && lessonResult?.data?._id && lessonData.thumbnailFile) {
        try {
          await uploadThumbnailForLesson(lessonResult.data._id, lessonData.thumbnailFile, 'video', localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')!)._id : '');
        } catch (thumbErr) {
          console.warn('Thumbnail upload failed (lesson was still created):', thumbErr);
        }
      }

      return lessonResult || { status: 500, message: 'Failed to create lesson' };
    }

    // ── Non-video (document / quiz): existing single-stream GraphQL Upload ──
    const formData = new FormData();
    formData.append('operations', JSON.stringify({
      query: `
        mutation createCourseModuleLesson(
          $file: Upload,
          $thumbnail: Upload,
          $courseId: ID!,
          $coursemoduleId: ID!,
          $title: String!,
          $description: String!,
          $lessonType: String,
          $order: Int,
          $duration: Int,
          $questions: [QuestionInput]
        ) {
          createCourseModuleLesson(
            courseId: $courseId,
            coursemoduleId: $coursemoduleId,
            title: $title,
            description: $description,
            content: $file,
            lessonThumbnail: $thumbnail,
            lessonType: $lessonType,
            order: $order,
            duration: $duration,
            questions: $questions
          ) {
            status
            message
            data {
              _id
              title
              lessonThumbnail
              questions { questionText options { answertext isCorrect explanation } }
              
            }
          }
        }
      `,
      variables: {
        file: lessonData.file ? null : undefined,
        thumbnail: lessonData.thumbnailFile ? null : undefined,
        courseId: lessonData.courseId,
        coursemoduleId: lessonData.coursemoduleId,
        title: lessonData.title,
        description: lessonData.description,
        lessonType: lessonData.lessonType,
        order: lessonData.order,
        duration: lessonData.duration !== null ? lessonData.duration : undefined,
        questions: lessonData.questions || [],
      },
    }));

    const fileMap: Record<string, string[]> = {};
    if (lessonData.file) fileMap['0'] = ['variables.file'];
    if (lessonData.thumbnailFile) fileMap['1'] = ['variables.thumbnail'];
    formData.append('map', JSON.stringify(fileMap));

    if (lessonData.file) formData.append('0', lessonData.file);
    if (lessonData.thumbnailFile) formData.append('1', lessonData.thumbnailFile);

    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}` },
      body: formData,
    });

    const result = await response.json();
    console.log("GraphQL response:", result);
    return result.data?.createCourseModuleLesson || { status: 500, message: 'Failed to create lesson' };
  } catch (error: any) {
    console.error('Error creating lesson:', error);
    return { status: 500, message: error.message || 'Error creating lesson' };
  }
};

// In src/api/courseService.ts

export const updateCourseModuleLesson = async (
  lessonData: {
    id: string;
    user_id: string;
    title?: string;
    description?: string;
    lessonType?: string;
    duration?: number | null;
    order?: number;
    file?: File;
    thumbnailFile?: File;
    lessonThumbnail?: File | null;
    content?: string;
    questions?: any[];
  },
  onProgress?: (percent: number) => void
) => {
  try {
    // ── Video lesson with a new content file: use chunked upload ────────────
    if (lessonData.lessonType === 'video' && lessonData.file) {
      const uploadedFilePath = await uploadFileInChunks(lessonData.file, onProgress);
      console.log("Chunked update upload complete, assembled path:", uploadedFilePath);

      const thumbnailFileObj = lessonData.lessonThumbnail instanceof File
        ? lessonData.lessonThumbnail
        : lessonData.thumbnailFile instanceof File
          ? lessonData.thumbnailFile
          : null;

      // NOTE: lessonThumbnail is intentionally excluded from this mutation — see
      // createCourseModuleLesson for the reason. We upload it separately below.
      const inputPayload: any = {
        title: lessonData.title,
        description: lessonData.description,
        lessonType: lessonData.lessonType,
        duration: lessonData.duration !== null ? lessonData.duration : undefined,
        order: lessonData.order,
        questions: lessonData.questions || [],
        uploadedFilePath,
      };

      const variables: any = {
        id: lessonData.id,
        user_id: lessonData.user_id,
        input: inputPayload
      };

      const gqlQuery = `
        mutation UpdateCourseModuleLesson($id: ID!, $user_id: String, $input: UpdateCourseLessonInput!) {
          updateCourseModuleLesson(id: $id, user_id: $user_id, input: $input) {
            status
            message
            data {
              _id title description content lessonThumbnail lessonType order duration updatedBy updatedAt
              questions { questionText options { answertext isCorrect explanation } }
            }
          }
        }
      `;

      const formData = new FormData();
      formData.append('operations', JSON.stringify({ query: gqlQuery, variables }));
      formData.append('map', '{}');

      const response = await fetch(`${API_COURSE_URL}/graphql`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}` },
        body: formData,
      });

      const result = await response.json();
      console.log("Update lesson response (chunked):", result);
      const updateResult = result.data?.updateCourseModuleLesson;

      // Step 2: attach thumbnail via a separate small upload (avoids Upload scalar issue)
      if (updateResult?.status < 400 && thumbnailFileObj) {
        try {
          await uploadThumbnailForLesson(lessonData.id, thumbnailFileObj, lessonData.lessonType || 'video', lessonData.user_id);
        } catch (thumbErr) {
          console.warn('Thumbnail upload failed (lesson was still updated):', thumbErr);
        }
      }

      return updateResult || { status: 500, message: 'Failed to update lesson' };
    }

    // ── All other cases: existing FormData / JSON flow (unchanged) ───────────
    // Check if we have files to upload
    const hasFiles = lessonData.file || lessonData.thumbnailFile || (lessonData.lessonThumbnail !== undefined);
    
    if (hasFiles) {
      // Use FormData for file upload
      const formData = new FormData();
      
      // Build the map object conditionally
      const map: Record<string, string[]> = {};
      let fileIndex = 0;
      
      // Prepare variables - always include lessonType
      const variables: any = {
        id: lessonData.id,
        user_id: lessonData.user_id,
        input: {
          title: lessonData.title,
          description: lessonData.description,
          lessonType: lessonData.lessonType,
          duration: lessonData.duration !== null ? lessonData.duration : undefined,
          order: lessonData.order !== null ? lessonData.order : undefined,
          questions: lessonData.questions || []
        }
      };
      
      // Only add file to variables and map if it exists
      if (lessonData.file) {
        variables.input.content = null;
        map[fileIndex.toString()] = ["variables.input.content"];
        fileIndex++;
      } else if (lessonData.content) {
        // Preserve existing content URL if no new file is being uploaded
        variables.input.content = lessonData.content;
      }
      
      // FIXED: Handle thumbnail for video lessons
      if (lessonData.lessonThumbnail !== undefined) {
        // This is for video lessons where we explicitly want to update the thumbnail
        if (lessonData.lessonThumbnail === null) {
          // Explicitly remove the thumbnail
          variables.input.lessonThumbnail = null;
          map[fileIndex.toString()] = ["variables.input.lessonThumbnail"];
          fileIndex++;
        } else if (lessonData.lessonThumbnail) {
          // Upload new thumbnail
          variables.input.lessonThumbnail = null;
          map[fileIndex.toString()] = ["variables.input.lessonThumbnail"];
          fileIndex++;
        }
        // If lessonThumbnail is undefined, we don't send anything to preserve existing
      } 
      // Handle thumbnail for non-video lessons (backward compatibility)
      else if (lessonData.thumbnailFile) {
        variables.input.lessonThumbnail = null;
        map[fileIndex.toString()] = ["variables.input.lessonThumbnail"];
        fileIndex++;
      }
      
      formData.append('operations', JSON.stringify({
        query: `
          mutation UpdateCourseModuleLesson($id: ID!, $user_id: String, $input: UpdateCourseLessonInput!) {
            updateCourseModuleLesson(id: $id, user_id: $user_id, input: $input) {
              status
              message
              data {
                _id
                title
                description
                content
                lessonThumbnail
                lessonType
                order
                duration
                updatedBy
                updatedAt
                questions {
                  questionText
                  options {
                    answertext
                    isCorrect
                    explanation
                  }
                }
              }
            }
          }
        `,
        variables
      }));
      
      // Only add map if there are files to upload
      if (Object.keys(map).length > 0) {
        formData.append('map', JSON.stringify(map));
        
        // Reset fileIndex for appending files
        fileIndex = 0;
        
        if (lessonData.file) {
          formData.append(fileIndex.toString(), lessonData.file);
          fileIndex++;
        }
        
        // FIXED: Handle thumbnail for video lessons
        if (lessonData.lessonThumbnail !== undefined && lessonData.lessonThumbnail) {
          formData.append(fileIndex.toString(), lessonData.lessonThumbnail);
          fileIndex++;
        } 
        // Handle thumbnail for non-video lessons (backward compatibility)
        else if (lessonData.thumbnailFile) {
          formData.append(fileIndex.toString(), lessonData.thumbnailFile);
        }
      }
      
      const response = await fetch(`${API_COURSE_URL}/graphql`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
        },
        body: formData
      });
      
      const result = await response.json();
      console.log("Update lesson response:", result);
      
      return result.data?.updateCourseModuleLesson || {
        status: 500,
        message: 'Failed to update lesson'
      };
    } else {
      // Use regular JSON request without files
      const response = await fetch(`${API_COURSE_URL}/graphql`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
        },
        body: JSON.stringify({
          query: `
            mutation UpdateCourseModuleLesson($id: ID!, $user_id: String, $input: UpdateCourseLessonInput!) {
              updateCourseModuleLesson(id: $id, user_id: $user_id, input: $input) {
                status
                message
                data {
                  _id
                  title
                  description
                  content
                  lessonThumbnail
                  lessonType
                  order
                  duration
                  updatedAt
                  updatedBy                   
                  questions {
                    questionText
                    options {
                      answertext
                      isCorrect
                      explanation
                    }
                  }
                }
              }
            }
          `,
          variables: {
            id: lessonData.id,
            user_id: lessonData.user_id,  
            input: {
              title: lessonData.title,
              description: lessonData.description,
              lessonType: lessonData.lessonType,
              duration: lessonData.duration !== null ? lessonData.duration : undefined,
              order: lessonData.order !== null ? lessonData.order : undefined,
              content: lessonData.content,
              questions: lessonData.questions || []
            }
          }
        })
      });
      
      const result = await response.json();
      console.log("Update lesson response (no files):", result);
      
      return result.data?.updateCourseModuleLesson || {
        status: 500,
        message: 'Failed to update lesson'
      };
    }
  } catch (error: any) {
    console.error('Error updating lesson:', error);
    return {
      status: 500,
      message: error.message || 'Error updating lesson'
    };
  }
};

export const createCourseCertificate = async (certificateData: {
  courseId: string;
  templateID: number;
  title: string;
  subtext?: string;
  description?: string;
  certificateLogo: File;
  signature: {
    name: string;
    designation: string;
  };
  signatureFile: File;
  createdBy: string;
}): Promise<CertificateResponse> => {
  try {
    const formData = new FormData();
    
    formData.append('operations', JSON.stringify({
      query: `
        mutation createCourseCertificate(
          $courseId: String!, 
          $templateID: Int!, 
          $title: String!, 
          $subtext: String, 
          $description: String, 
          $certificateLogo: Upload!, 
          $signatureFile: Upload!, 
          $createdBy: String!,
          $sigName: String!,
          $sigDesignation: String!
        ) {
          createCourseCertificate(
            courseId: $courseId, 
            templateID: $templateID, 
            title: $title, 
            subtext: $subtext, 
            description: $description, 
            certificateLogo: $certificateLogo, 
            signature: [
              { name: $sigName, designation: $sigDesignation, image: $signatureFile }
            ], 
            createdBy: $createdBy                        
          ) {
            status
            message

            data {
              _id
              title
              subtext
              description
              certificateLogo
              signature {
                name
                designation
                image
              }
            }
          }
        }
      `,
      variables: {
        courseId: certificateData.courseId,
        templateID: certificateData.templateID,
        title: certificateData.title,
        subtext: certificateData.subtext,
        description: certificateData.description,
        certificateLogo: null,
        signatureFile: null,
        createdBy: certificateData.createdBy,
        sigName: certificateData.signature.name,
        sigDesignation: certificateData.signature.designation
      }
    }));
    
    formData.append('map', JSON.stringify({
      "0": ["variables.certificateLogo"],
      "1": ["variables.signatureFile"]
    }));
    
    formData.append('0', certificateData.certificateLogo);
    formData.append('1', certificateData.signatureFile);
    
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: formData
    });
    
    const result = await response.json();
    
    // Check for GraphQL errors
    if (result.errors && result.errors.length > 0) {
      console.error("GraphQL errors:", result.errors);
      return {
        status: 500,
        message: result.errors[0].message || "GraphQL error occurred"
      };
    }
    
    return result.data?.createCourseCertificate || {
      status: 500,
      message: 'Failed to create certificate'
    };
  } catch (error: any) {
    console.error('Error creating certificate:', error);
    return {
      status: 500,
      message: error.message || 'Error creating certificate'
    };
  }
};

export const updateCourseCertificate = async (certificateData: {
  id: string;
  user_id: string;
  title?: string;
  subtext?: string;
  description?: string;
  certificateLogo?: File;
  signature: {
    name: string;
    designation: string;
  };
  signatureFile?: File;
}): Promise<CertificateResponse> => {
  try {
    const hasFiles = certificateData.certificateLogo || certificateData.signatureFile;
    
    if (hasFiles) {
      // Use FormData for file upload
      const formData = new FormData();
      
      // Prepare variables
      const variables: any = {
        id: certificateData.id,
        user_id: certificateData.user_id,
        title: certificateData.title,
        subtext: certificateData.subtext,
        description: certificateData.description,
      };
      
      // Build the map object
      const map: Record<string, string[]> = {};
      let fileIndex = 0;
      
      // Handle certificate logo
      if (certificateData.certificateLogo) {
        variables.certificateLogo = null;
        map[fileIndex.toString()] = ["variables.certificateLogo"];
        fileIndex++;
      }
      
      // Handle signature and signature image
      if (certificateData.signatureFile) {
        // Create signature array with image placeholder only when uploading a new image
        variables.signature = [{
          name: certificateData.signature.name,
          designation: certificateData.signature.designation,
          image: null
        }];
        map[fileIndex.toString()] = ["variables.signature.0.image"];
        fileIndex++;
      } else {
        // Create signature array WITHOUT image field when no new image is uploaded
        // This will tell the backend to preserve the existing image
        variables.signature = [{
          name: certificateData.signature.name,
          designation: certificateData.signature.designation
          // NOTE: Not including 'image' field at all
        }];
      }
      
console.log("Certificate update variables:", variables);

      // FIRST: Append operations
      formData.append('operations', JSON.stringify({
        query: `
          mutation updateCourseCertificate(
            $id: String!, 
            $title: String, 
            $subtext: String, 
            $user_id: String,
            $description: String,
            $certificateLogo: Upload, 
            $signature: [SignatureInput],          
          ) {
            updateCourseCertificate(
              id: $id, 
              title: $title, 
              subtext: $subtext, 
              description: $description,
              certificateLogo: $certificateLogo, 
              signature: $signature,
              user_id: $user_id
            ) {
              status
              message
              data {
                _id
                title
                subtext
                description
                certificateLogo
                updatedBy {
                  _id
                  name
                }
                updatedAt
                signature {
                  name
                  designation
                  image
                }
              }
            }
          }
        `,
        variables
      }));
      
      // SECOND: Append map (only if there are files)
      if (Object.keys(map).length > 0) {
        formData.append('map', JSON.stringify(map));
      }
      
      // THIRD: Append files
      fileIndex = 0; // Reset file index for appending files
      
      if (certificateData.certificateLogo) {
        formData.append(fileIndex.toString(), certificateData.certificateLogo);
        fileIndex++;
      }
      
      if (certificateData.signatureFile) {
        formData.append(fileIndex.toString(), certificateData.signatureFile);
      }
      
      const response = await fetch(`${API_COURSE_URL}/graphql`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
        },
        body: formData
      });
      
      const result = await response.json();
      
      // Check for GraphQL errors
      if (result.errors && result.errors.length > 0) {
        console.error("GraphQL errors:", result.errors);
        return {
          status: 500,
          message: result.errors[0].message || "GraphQL error occurred"
        };
      }
      
      return result.data?.updateCourseCertificate || {
        status: 500,
        message: 'Failed to update certificate'
      };
    } else {
      // Use regular JSON request without files
      const response = await fetch(`${API_COURSE_URL}/graphql`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
        },
        body: JSON.stringify({
          query: `
            mutation updateCourseCertificate(
              $id: String!, 
              $title: String, 
              $subtext: String, 
              $user_id: String!,
              $description: String,
              $signature: [SignatureInput],
              
            ) {
              updateCourseCertificate(
                id: $id, 
                user_id: $user_id,
                title: $title, 
                subtext: $subtext, 
                description: $description,
                signature: $signature,
              ) {
                status
                message
                data {
                  _id
                  title
                  subtext
                  description
                  certificateLogo
                  updatedBy {
                    _id
                    name
                  }
                  updatedAt
                  signature {
                    name
                    designation
                    image
                  }
                }
              }
            }
          `,
          variables: {
            id: certificateData.id,
            user_id: certificateData.user_id,
            title: certificateData.title,
            subtext: certificateData.subtext,
            description: certificateData.description,
            signature: [{
              name: certificateData.signature.name,
              designation: certificateData.signature.designation
              // IMPORTANT: Not including 'image' field so backend preserves existing image
            }],
          }
        })
      });
      
      const result = await response.json();
      
      // Check for GraphQL errors
      if (result.errors && result.errors.length > 0) {
        console.error("GraphQL errors:", result.errors);
        return {
          status: 500,
          message: result.errors[0].message || "GraphQL error occurred"
        };
      }
      
      return result.data?.updateCourseCertificate || {
        status: 500,
        message: 'Failed to update certificate'
      };
    }
  } catch (error: any) {
    console.error('Error updating certificate:', error);
    return {
      status: 500,
      message: error.message || 'Error updating certificate'
    };
  }
};

export const getAllGstRates = async (): Promise<ApiResponse> => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          query getallGstRate {
            allGSTRates {
              status
              message
              data {
                _id
                gstPercent
              }
            }
          }
        `
      })
    });
    const result = await response.json();
    
    if (result.data?.allGSTRates) {
      return {
        status: result.data.allGSTRates.status,
        message: result.data.allGSTRates.message,
        data: result.data.allGSTRates.data
      };
    }
    
    return {
      status: 500,
      message: 'Failed to fetch GST rates'
    };
  } catch (error: any) {
    console.error('Error fetching GST rates:', error);
    return {
      status: 500,
      message: error.message || 'Failed to fetch GST rates'
    };
  }
};

// NEW PRICING FUNCTIONS
export const createCoursePrice = async (priceData: {
  courseId: string;
  createdBy: string;
  priceDetail: PriceDetail[];
}): Promise<ApiResponse> => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          mutation CreateCoursePrice(
            $courseId: String!
            $createdBy: String!
            $priceDetail: [PriceDetailInputType]
          ) {
            createCoursePrice(
              courseId: $courseId
              createdBy: $createdBy
              priceDetail: $priceDetail
            ) {
              status
              message
              data {
                _id
                courseId { _id title }
                priceDetail {
                  price
                  actualPrice
                  validityType
                  validityInDays
                  gstRateId { _id gstPercent }
                }
                createdAt               
                
              }
            }
          }
        `,
        variables: priceData
      })
    });
    
    const result = await response.json();
    
    if (result.errors && result.errors.length > 0) {
      console.error("GraphQL errors:", result.errors);
      return {
        status: 400,
        message: result.errors[0].message || "GraphQL error occurred"
      };
    }
    
    return result.data?.createCoursePrice || {
      status: 500,
      message: 'Failed to create course price'
    };
  } catch (error: any) {
    console.error('Error creating course price:', error);
    return {
      status: 500,
      message: error.message || 'Error creating course price'
    };
  }
};

export const updateCoursePrice = async (priceData: {
  id: string;
  user_id: string;
  priceDetail: PriceDetail[];
}): Promise<ApiResponse> => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          mutation UpdateCoursePrice(
            $id: String!
            $user_id: String!
            $priceDetail: [UpdatePriceDetailInputType]
          ) {
            updateCoursePrice(
              id: $id
              user_id: $user_id
              priceDetail: $priceDetail              
            ) {
              status
              message
              data {
                _id
                courseId { _id title }
                priceDetail {
                  price
                  actualPrice
                  validityType
                  validityInDays
                  gstRateId { _id gstPercent }
                }
                updatedBy { _id name }
                updatedAt
              }
            }
          }
        `,
        variables: priceData
      })
    });
    
    const result = await response.json();
    
    if (result.errors && result.errors.length > 0) {
      console.error("GraphQL errors:", result.errors);
      return {
        status: 400,
        message: result.errors[0].message || "GraphQL error occurred"
      };
    }
    
    return result.data?.updateCoursePrice || {
      status: 500,
      message: 'Failed to update course price'
    };
  } catch (error: any) {
    console.error('Error updating course price:', error);
    return {
      status: 500,
      message: error.message || 'Error updating course price'
    };
  }
};

export const getCoursePriceByCourseId = async (courseId: string): Promise<ApiResponse> => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          query GetCoursePriceByCourseId($id: String!) {
            coursePriceByCourseId(id: $id) {
              status
              message
              data {
                _id
                courseId { _id title }
                priceDetail {
                  _id
                  price
                  actualPrice
                  validityType
                  validityInDays
                  gstRateId { _id gstPercent }
                }
                createdBy { _id name }
                createdAt
              }
            }
          }
        `,
        variables: { id: courseId }
      })
    });
    
    const result = await response.json();
    
    if (result.data?.coursePriceByCourseId) {
      return {
        status: result.data.coursePriceByCourseId.status,
        message: result.data.coursePriceByCourseId.message,
        data: result.data.coursePriceByCourseId.data
      };
    }
    
    return {
      status: 500,
      message: 'Failed to fetch course price'
    };
  } catch (error: any) {
    console.error('Error fetching course price:', error);
    return {
      status: 500,
      message: error.message || 'Error fetching course price'
    };
  }
};

export const getCoursePrice = async (id: string): Promise<ApiResponse> => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          query GetCoursePrice($id: String!) {
            coursePrice(id: $id) {
              status
              message
              data {
                _id
                courseId { _id title }
                priceDetail {
                  price
                  actualPrice
                  validityType
                  validityInDays
                  gstRateId { _id gstPercent }
                }
                createdBy { _id name }
                updatedBy { _id name }
                createdAt
                updatedAt
              }
            }
          }
        `,
        variables: { id }
      })
    });
    
    const result = await response.json();
    
    if (result.data?.coursePrice) {
      return {
        status: result.data.coursePrice.status,
        message: result.data.coursePrice.message,
        data: result.data.coursePrice.data
      };
    }
    
    return {
      status: 500,
      message: 'Failed to fetch course price'
    };
  } catch (error: any) {
    console.error('Error fetching course price:', error);
    return {
      status: 500,
      message: error.message || 'Error fetching course price'
    };
  }
};

export const createCourseAdditional = async (additionalData: {
  courseId: string;
  removeWatermark: boolean;
  FAQ: {
    question: string;
    answer: string;
  }[];
  status: string;
}) => {
  try {
    console.log("Calling createCourseAdditional API with data:", additionalData);
    
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          mutation createCourseAdditional($courseId: String!, $removeWatermark: Boolean, $FAQ: [FAQInput!]!,$status:String, ) {
            createCourseAdditional(courseId: $courseId, removeWatermark: $removeWatermark, FAQ: $FAQ,status:$status, ) {
              status
              message

              data {
                _id
                courseId {
                  _id
                  title
                }
                removeWatermark
                FAQ {
                  question
                  answer
                }
                createdAt
               
              }
            }
          }
        `,
        variables: additionalData
      })
    });
    
    const result = await response.json();
    console.log("createCourseAdditional API response:", result);
    
    if (result.errors && result.errors.length > 0) {
      console.error("GraphQL errors:", result.errors);
      return {
        status: 400,
        message: result.errors[0].message || "GraphQL error occurred"
      };
    }
    
    return result.data?.createCourseAdditional || {
      status: 500,
      message: 'Failed to create course additional details'
    };
  } catch (error: any) {
    console.error('Error creating course additional details:', error);
    return {
      status: 500,
      message: error.message || 'Error creating course additional details'
    };
  }
};

export const updateCourseAdditional = async (additionalData: {
  id: string;
  removeWatermark?: boolean;
  user_id?: string;
  FAQ?: {
    question: string;
    answer: string;
  }[];
}) => {
  try {
    console.log("Calling updateCourseAdditional API with data:", additionalData);
    
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          mutation updateCourseAdditional($id: String!, $user_id: String, $removeWatermark: Boolean, $FAQ: [FAQInput]) {
            updateCourseAdditional(id: $id, user_id: $user_id, removeWatermark: $removeWatermark, FAQ: $FAQ) {
              status
              message
              data {
                _id
                courseId {
                  _id
                  title
                }
                removeWatermark
                FAQ {
                  question
                  answer
                }
                createdAt
                updatedBy                                 
                updatedAt
                 
              }
            }
          }
        `,
        variables: additionalData
      })
    });
    
    const result = await response.json();
    console.log("updateCourseAdditional API response:", result);
    
    if (result.errors && result.errors.length > 0) {
      console.error("GraphQL errors:", result.errors);
      return {
        status: 400,
        message: result.errors[0].message || "GraphQL error occurred"
      };
    }
    
    return result.data?.updateCourseAdditional || {
      status: 500,
      message: 'Failed to update course additional details'
    };
  } catch (error: any) {
    console.error('Error updating course additional details:', error);
    return {
      status: 500,
      message: error.message || 'Error updating course additional details'
    };
  }
};

export const getAllCourseModules = async (): Promise<ApiResponse> => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          query getallCourseModule {
            allCoursesModule {
              status
              message
              data {
                _id
                title
                description
                order
                courseId {
                  _id
                  title
                }
              }
            }
          }
        `
      })
    });
    const result = await response.json();
    
    if (result.data?.allCoursesModule) {
      return {
        status: result.data.allCoursesModule.status,
        message: result.data.allCoursesModule.message,
        data: result.data.allCoursesModule.data
      };
    }
    
    return {
      status: 500,
      message: 'Failed to fetch course modules'
    };
  } catch (error: any) {
    console.error('Error fetching course modules:', error);
    return {
      status: 500,
      message: error.message || 'Failed to fetch course modules'
    };
  }
};

export const getLessonsByModuleId = async (moduleId: string): Promise<ApiResponse> => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          query GetAllLessonBYModuleId($ID: ID!) {
            allLessonBYModuleID(moduleId: $ID) {
              status
              message
              data {
                _id
                title
                description
                content
                lessonThumbnail
                lessonType
                duration
                videoStatus
                questions {
                  questionText
                  options {
                    answertext
                    isCorrect
                    explanation
                  }
                }
              }
            }
          }
        `,
        variables: { ID: moduleId }
      })
    });
    const result = await response.json();
    
    if (result.data?.allLessonBYModuleID) {
      // Process thumbnails and content to add token
      const lessonsWithToken = result.data.allLessonBYModuleID.data.map((lesson: any) => ({
        ...lesson,
        // Map 'assignment' to 'document' for UI consistency
        lessonType: lesson.lessonType === 'assignment' ? 'document' : lesson.lessonType,
        lessonThumbnail: appendTokenToUrl(lesson.lessonThumbnail),
        // Only append token to content if it's not a base64 data
        content: lesson.content?.startsWith('data:') 
          ? lesson.content 
          : appendTokenToUrl(lesson.content)
      }));
      
      return {
        status: result.data.allLessonBYModuleID.status,
        message: result.data.allLessonBYModuleID.message,
        data: lessonsWithToken
      };
    }

    console.log("Lessons fetch result:", result.data);
    
    return {
      status: 500,
      message: 'Failed to fetch lessons'
    };
  } catch (error: any) {
    console.error('Error fetching lessons:', error);
    return {
      status: 500,
      message: error.message || 'Failed to fetch lessons'
    };
  }
};

export const getCourseModuleById = async (id: string): Promise<ApiResponse> => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          query getCourseModule($id: String!) {
            courseModule(id: $id) {
              status
              message
              data {
                _id
                title
                description
                order
                courseId {
                  _id
                  title
                }
              }
            }
          }
        `,
        variables: { id }
      })
    });
    const result = await response.json();
    return result.data?.courseModule || {
      status: 500,
      message: 'Failed to fetch course module'
    };
  } catch (error: any) {
    return {
      status: 500,
      message: error.message || 'Error fetching course module'
    };
  }
};

export const getLessonById = async (id: string): Promise<ApiResponse> => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          query getCourseModuleLesson($id: ID!) {
            courseModuleLesson(id: $id) {
              status
              message
              data {
                _id
                title
                description
                lessonType
                content
                lessonThumbnail
                order
                duration
                questions {
                  questionText
                  options {
                    answertext
                    isCorrect
                    explanation
                  }
                }
              }
            }
          }
        `,
        variables: { id }
      })
    });
    const result = await response.json();
    
    if (result.data?.courseModuleLesson) {
      // Map 'assignment' to 'document' for UI consistency
      const lessonData = {
        ...result.data.courseModuleLesson.data,
        lessonType: result.data.courseModuleLesson.data.lessonType === 'assignment' 
          ? 'document' 
          : result.data.courseModuleLesson.data.lessonType
      };
      
      return {
        status: result.data.courseModuleLesson.status,
        message: result.data.courseModuleLesson.message,
        data: lessonData
      };
    }
    
    return result.data?.courseModuleLesson || {
      status: 500,
      message: 'Failed to fetch lesson'
    };
  } catch (error: any) {
    return {
      status: 500,
      message: error.message || 'Error fetching lesson'
    };
  }
};

export const getCourseAdditionalById = async (id: string): Promise<ApiResponse> => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          query getCourseAdditionalByID($id:String){
            courseAdditional(id:$id){
              status
              message
              data{
                _id
                FAQ{
                  question
                  answer
                }
                removeWatermark
                courseId{
                  _id
                  title
                }
              }
            }
          }
        `,
        variables: { id }
      })
    });
    const result = await response.json();
    return result.data?.courseAdditional || {
      status: 500,
      message: 'Failed to fetch course additional'
    };
  } catch (error: any) {
    return {
      status: 500,
      message: error.message || 'Error fetching course additional'
    };
  }
};



export const updateCourseStatus = async (id: string, publishStatus: string, user_id: string): Promise<ApiResponse> => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          mutation updateCourseStatus($id: String!, $publishStatus: String, $user_id: String!) {
            updateCourseStatus(
              id: $id,
              publishStatus: $publishStatus,
              user_id: $user_id
            ) {
              status
              message
              data {
                _id
                title
                thumbnail
                PublishStatus
                
                
              }
            }
          }
        `,
        variables: {
          id,
          publishStatus,
          user_id,
        }
      })
    });
    const result = await response.json();
    
    // Check for GraphQL errors first
    if (result.errors && result.errors.length > 0) {
      console.error('GraphQL errors:', result.errors);
      return {
        status: 400,
        message: result.errors[0].message || 'GraphQL error occurred'
      };
    }
    
    // Return the correct response object
    return result.data?.updateCourseStatus || {
      status: 500,
      message: 'Failed to update course status'
    };
  } catch (error: any) {
    console.error('Error updating course status:', error);
    return {
      status: 500,
      message: error.message || 'Error updating course status'
    };
  }
};

export const getCourseMembers = async (courseId: string): Promise<CourseMembersResponse> => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          query getCourseMembers($courseId: String!) {
            getCourseMembers(courseId: $courseId) {
              status
              message
              totalMembers
              totalWatched
              data {
                userId
                name
                email
                phone
                purchasedAt
                courseViewPercent
                certificateSent
                totalWatchTime
                hasWatched
                accessType
              }
            }
          }
        `,
        variables: { courseId }
      })
    });
    const result = await response.json();

    if (result.errors && result.errors.length > 0) {
      console.error('GraphQL errors:', result.errors);
      return {
        status: 400,
        message: result.errors[0].message || 'GraphQL error occurred'
      };
    }

    return result.data?.getCourseMembers || {
      status: 500,
      message: 'Failed to fetch course members'
    };
  } catch (error: any) {
    console.error('Error fetching course members:', error);
    return {
      status: 500,
      message: error.message || 'Error fetching course members'
    };
  }
};

export const getAllGroups = async (): Promise<GroupListResponse> => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          query getAllGroups {
            getAllGroups {
              status
              message
              data {
                id
                name
                slug
                channelType
              }
            }
          }
        `
      })
    });
    const result = await response.json();

    if (result.errors && result.errors.length > 0) {
      console.error('GraphQL errors:', result.errors);
      return {
        status: 400,
        message: result.errors[0].message || 'GraphQL error occurred'
      };
    }

    return result.data?.getAllGroups || {
      status: 500,
      message: 'Failed to fetch groups'
    };
  } catch (error: any) {
    console.error('Error fetching groups:', error);
    return {
      status: 500,
      message: error.message || 'Error fetching groups'
    };
  }
};

export const getCourseAdditionalByCourseId = async (courseId: string): Promise<ApiResponse> => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          query getAllCourseAdditionalByCourseID($id: String) {
            courseAdditionalByCourseId(id: $id) {
              status
              message
              data {
                _id
                FAQ {
                  question
                  answer
                }
                removeWatermark
                courseId {
                  _id
                  title
                }
              }
            }
          }
        `,
        variables: { id: courseId }
      })
    });
    const result = await response.json();
    
    if (result.data?.courseAdditionalByCourseId) {
      return {
        status: result.data.courseAdditionalByCourseId.status,
        message: result.data.courseAdditionalByCourseId.message,
        data: result.data.courseAdditionalByCourseId.data
      };
    }
    
    return {
      status: 500,
      message: 'Failed to fetch course additional data'
    };
  } catch (error: any) {
    console.error('Error fetching course additional data:', error);
    return {
      status: 500,
      message: error.message || 'Error fetching course additional data'
    };
  }
};

export const getCourseModulesByCourseId = async (courseId: string): Promise<ApiResponse> => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `query getCourseModuleBYCourseID($id: String!) { allCoursesModulebyCourseId(id: $id) { status message data { _id title description order courseId { _id title } } } }`,
        variables: { id: courseId }
      })
    });
    const result = await response.json();
    
    if (result.data?.allCoursesModulebyCourseId) {
      return {
        status: result.data.allCoursesModulebyCourseId.status,
        message: result.data.allCoursesModulebyCourseId.message,
        data: result.data.allCoursesModulebyCourseId.data
      };
    }
    
    return {
      status: 500,
      message: 'Failed to fetch course modules'
    };
  } catch (error: any) {
    console.error('Error fetching course modules:', error);
    return {
      status: 500,
      message: error.message || 'Error fetching course modules'
    };
  }
};

export const getCourseCertificatesByCourseId = async (courseId: string): Promise<ApiResponse> => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          query getCourseCertificatesByCourseId($courseId: String!) {
            CourseCertificatesByCourseId(id: $courseId) {
              status
              message
              data {
                _id
                title
                subtext
                description
                certificateLogo
                signature {
                  name
                  designation
                  image
                }
                courseId {
                  _id
                }
              }
            }
          }
        `,
        variables: { courseId }
      })
    });
    const result = await response.json();
    
    if (result.data?.CourseCertificatesByCourseId) {
      // Process certificateLogo and signature image to add token
      const certificatesWithToken = result.data.CourseCertificatesByCourseId.data.map((certificate: any) => ({
        ...certificate,
        certificateLogo: appendTokenToUrl(certificate.certificateLogo),
        signature: certificate.signature?.map((sig: any) => ({
          ...sig,
          image: appendTokenToUrl(sig.image)
        }))
      }));
      
      return {
        status: result.data.CourseCertificatesByCourseId.status,
        message: result.data.CourseCertificatesByCourseId.message,
        data: certificatesWithToken
      };
    }
    
    return {
      status: 500,
      message: 'Failed to fetch course certificates'
    };
  } catch (error: any) {
    console.error('Error fetching course certificates:', error);
    return {
      status: 500,
      message: error.message || 'Error fetching course certificates'
    };
  }
};



export const softDeleteCourse = async (id: string, deletedBy: string): Promise<ApiResponse> => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          mutation softDeleteCourse($id: String!, $deletedBy: String) {
            softDeleteCourse(
              id: $id, 
              deletedBy: $deletedBy
            ) {
              status
              message
              data {
                _id
                title
                isDeleted
              }
            }
          }
        `,
        variables: { id, deletedBy }
      })
    });
    const result = await response.json();
    return result.data?.softDeleteCourse || {
      status: 500,
      message: 'Failed to delete course'
    };
  } catch (error: any) {
    console.error('Error deleting course:', error);
    return {
      status: 500,
      message: error.message || 'Error deleting course'
    };
  }
};

export const permanentDeleteCourse = async (id: string): Promise<ApiResponse> => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
      },
      body: JSON.stringify({
        query: `
          mutation permanentDeleteCourse($id: String!) {
            permanentDeleteCourse(id: $id) {
              status
              message
              data {
                _id
                title
              }
            }
          }
        `,
        variables: { id }
      })
    });
    const result = await response.json();
    return result.data?.permanentDeleteCourse || {
      status: 500,
      message: 'Failed to permanently delete course'
    };
  } catch (error: any) {
    console.error('Error permanently deleting course:', error);
    return {
      status: 500,
      message: error.message || 'Error permanently deleting course'
    };
  }
};

export const updateLessonOrder = async (
  lessonId: string,
  order: number,
) => {
  try {
    const response = await fetch(`${API_COURSE_URL}/graphql`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`,
      },
      body: JSON.stringify({
        query: `
          mutation UpdateCourseModuleLesson(
            $id: ID!,
            $input: UpdateCourseLessonInput!,
          ) {
            updateCourseModuleLesson(
              id: $id,
              input: $input
            ) {
              status
              message
              data {
                _id
                order
              }            
            }
          }
        `,
        variables: {
          id: lessonId,
          input: {
            order,
          },
        },
      }),
    });

    const result = await response.json();

    console.log("Update lesson order response:", result);

    if (result.errors) {
      console.error("GraphQL order update error:", result.errors);

      return {
        status: 500,
        message: result.errors[0]?.message || "GraphQL order update failed",
      };
    }

    return (
      result.data?.updateCourseModuleLesson || {
        status: 500,
        message: "Failed to update lesson order",
      }
    );
  } catch (error: any) {
    console.error("Error updating lesson order:", error);

    return {
      status: 500,
      message: error.message || "Error updating lesson order",
    };
  }
};